import {
  Boxes,
  ClipboardCheck,
  Gauge,
  Settings2,
  Sparkles,
} from "lucide-react";
import type { PageId } from "../types";

interface SidebarProps {
  activePage: PageId;
  mode?: "local" | "public_demo" | "public_paid";
  onNavigate: (page: PageId) => void;
}

const navItems: Array<{
  id: PageId;
  label: string;
  description: string;
  icon: typeof Gauge;
}> = [
  { id: "overview", label: "总览", description: "批次与流程", icon: Gauge },
  { id: "materials", label: "素材", description: "脚本与分镜", icon: Boxes },
  { id: "reviews", label: "审核", description: "风险与确认", icon: ClipboardCheck },
  { id: "adapters", label: "接入", description: "Adapter 状态", icon: Settings2 },
];

export function Sidebar({ activePage, mode, onNavigate }: SidebarProps) {
  const isPaid = mode === "public_paid";
  return (
    <aside className="sidebar">
      <div className="brand-block">
        <div className="brand-mark" aria-hidden="true">
          <Sparkles size={18} strokeWidth={2.4} />
        </div>
        <div>
          <strong>BatchCut</strong>
          <span>AI Production OS</span>
        </div>
      </div>

      <nav className="primary-nav" aria-label="主导航">
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <button
              type="button"
              key={item.id}
              className={activePage === item.id ? "nav-item is-active" : "nav-item"}
              onClick={() => onNavigate(item.id)}
              aria-label={item.label}
              aria-current={activePage === item.id ? "page" : undefined}
            >
              <Icon size={19} strokeWidth={1.9} aria-hidden="true" />
              <span>
                <strong>{item.label}</strong>
                <small>{item.description}</small>
              </span>
            </button>
          );
        })}
      </nav>

      <div className="sidebar-foot">
        <div className="mode-indicator">
          <span className="mode-dot" />
          <div>
            <strong>{isPaid ? "Access gated" : "Mock safe mode"}</strong>
            <span>{isPaid ? "六条真实生成路线" : "默认不产生费用"}</span>
          </div>
        </div>
        <p>{isPaid ? "public paid workspace" : "v0.2 local workspace"}</p>
      </div>
    </aside>
  );
}
